import { useConfig } from '../../../components/HotelDetailsOverlay/context/Config.js';
import { RATING_SENTIMENT_DISSATISFIED, RATING_SENTIMENT_HIGHLY_SATISFIED, RATING_SENTIMENT_SATISFIED, RATING_SENTIMENT_VERY_DISSATISFIED, RATING_SENTIMENT_VERY_SATISFIED } from '../../../primitives/Rating/index.js';
export const useRating = () => {
  const {
    rating: {
      scoreMaxBackend,
      scoreMaxFrontend,
      scoreThresholds
    }
  } = useConfig();
  const mapScoreToSentiment = score => {
    if (score >= scoreThresholds.excellent) {
      return RATING_SENTIMENT_HIGHLY_SATISFIED;
    }
    if (score >= scoreThresholds.veryGood) {
      return RATING_SENTIMENT_VERY_SATISFIED;
    }
    if (score >= scoreThresholds.good) {
      return RATING_SENTIMENT_SATISFIED;
    }
    if (score >= scoreThresholds.fair) {
      return RATING_SENTIMENT_DISSATISFIED;
    }
    return RATING_SENTIMENT_VERY_DISSATISFIED;
  };
  return rawScore => {
    const scoreScaled = rawScore / (scoreMaxBackend / scoreMaxFrontend);
    const score = Math.ceil(scoreScaled * 10) / 10;
    const scoreFormatted = score.toFixed(1);
    const scoreMax = scoreMaxFrontend.toFixed(1);
    const sentiment = mapScoreToSentiment(score);
    return {
      score,
      scoreFormatted,
      scoreMax,
      sentiment
    };
  };
};